import { Bones } from '@simplywallst/ui-core';
import {
  NameColumn,
  SnowflakeColumn,
  WatchlistColumn,
  SkeletonRow,
  SnowflakeBone,
} from './styled';

export interface Props {
  industry: string | 'any';
  isSticky: boolean;
  hideIndustryCol?: boolean;
}

const TableRowSkeleton = ({
  industry,
  isSticky,
  hideIndustryCol = false,
}: Props) => (
  <SkeletonRow>
    <SnowflakeColumn>
      <SnowflakeBone />
    </SnowflakeColumn>
    <NameColumn isSticky={isSticky}>
      <span className="!grid gap-x0_5">
        <Bones maxWidth="90%" />
        <Bones maxWidth="50%" minHeight="12px" />
      </span>
    </NameColumn>
    <td>
      <span>
        <Bones maxWidth="70%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="60%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="60%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="60%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="50%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="70%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="70%" />
      </span>
    </td>
    <td>
      <span>
        <Bones maxWidth="60%" />
      </span>
    </td>
    {industry === 'any' && hideIndustryCol === false && (
      <td>
        <span>
          <Bones maxWidth="70%" />
        </span>
      </td>
    )}
    <WatchlistColumn>
      <span>
        <Bones maxWidth="70%" />
      </span>
    </WatchlistColumn>
  </SkeletonRow>
);

export default TableRowSkeleton;
